import React, { useEffect } from 'react';
import useUiContext from '@groupefungo/react-apollo.core/ui/UseContext';
import ReactGA from 'react-ga4';

function ThankYou() {
  const { Button } = useUiContext();

  const handleContinue = () => {
    window.location = `https://${process.env.SHOPIFY_DOMAIN}/`;
  };

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      ReactGA.initialize('G-CMT6EYPT3K');
      ReactGA.event({
        category: 'va_booker',
        action: 'va_confirmed',
      });
    }
  }, []);

  return (
    <div className="text-container">
      <div className="welcome-body-wrapper">
        <div className="welcome-paragraph-wrapper">
          <h1>Your request has been submitted!</h1>
          <p>
            You should receive an email confirming the details you provided us, and a stylist will be in touch with you shortly!
          </p>
        </div>
        <div className="button-wrapper">
          <div className="form-btn primary-btn">
            <Button fullWidth onClick={handleContinue}>
              Return to Amsale
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
